import React from "react";
import Button from "./Button";
import { CardProps } from "./ComponentProps.js";
import { useTranslation } from "react-i18next";

const Card: React.FC<CardProps> = ({
  type,
  imageSrc,
  headerText,
  cardButtonStyles,
  pointers,
  buttonText,
  progressPercentage,
  onButtonClick,
  styles,
}) => {
  const isLarge = type === "large";
  const { t, i18n } = useTranslation();
  return (
    <div
      className={`bg-bgOffwhite shadow-md rounded-lg overflow-hidden ${
        isLarge ? "w-full max-w-lg flex flex-row" : "max-w-sm flex flex-col"
      }`}
      style={styles || undefined}
    >
      <div
        className={`${isLarge ? "w-1/2 flex min-h-full" : "w-full"} bg-bgGray`}
      >
        {imageSrc ? (
          <img
            src={imageSrc}
            alt="Card Image"
            className="w-full h-full object-cover"
          />
        ) : (
          <p className="text-bgGray m-auto">Image</p>
        )}
      </div>

      <div
        className={`${
          isLarge ? "w-1/2 p-6" : "p-4"
        } flex flex-col justify-between`}
      >
        <div>
          <h3
            className="text-sm text-left font-bold text-gray-800 mb-4"
            style={{
              textWrap: "nowrap",
            }}
          >
            {t(headerText)}
          </h3>

          {pointers?.map((pointer, index) => (
            <div key={index} className="flex  mb-2 text-left">
              {pointer.icon && (
                <span className="w-4 h-4 mr-1 mt-1 text-solidBlue">
                  {pointer.icon}
                </span>
              )}
              <p className="text-sm text-gray-600">{t(pointer.text)}</p>
            </div>
          ))}

          {isLarge && typeof progressPercentage === "number" && (
            <div className="mt-4">
              <p className="text-sm text-gray-500 mb-1">
                {progressPercentage}% Completed
              </p>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-solidGreen h-2 rounded-full"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-2">
          <Button
            type="GradientPrimaryButton"
            size="auto"
            text={t(buttonText)}
            onClick={onButtonClick}
            styles={cardButtonStyles || null}
          />
        </div>
      </div>
    </div>
  );
};

Card.defaultProps = {
  type: "large",
  imageSrc: null,
  headerText: "Sample Header Text",
  pointers: [],
  buttonText: "Button",
  progressPercentage: null,
  onButtonClick: () => {},
};

export default Card;
